import http from './HttpService';
import CountryUtils from '../utils/country-utils';
import UrlUtils from '../utils/url-utils/UrlUtils';

import urls from '../constants/Urls';

const countriesServiceBaseURL = process.env.REACT_APP_PARTNER_BASE_URL;

const getAllAvailable = async () => {
  let { data: availableCountries } = await http.get(
    `${countriesServiceBaseURL}${urls.GET_ALL_AVAILABLE_COUNTRIES}`,
  );
  availableCountries = availableCountries.map(country => {
    return {
      ...country,
      flag: country.flag && country.flag.replace('http://', 'https://'),
    };
  });
  return CountryUtils.sortByName(availableCountries);
};

const resolveCountry = (lat, lng) => {
  const params = { lat, lng };
  const uriWithParams = UrlUtils.replaceUrlParams(urls.RESOLVE_COUNTRY, params);
  return http.get(`${countriesServiceBaseURL}${uriWithParams}`);
};

export default {
  getAllAvailable,
  resolveCountry,
};
